module.exports = __webpack_public_path__ + "img/rcama.f5bb6792.svg";